__turbopack_context__.v({
  "buttonWrapper": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__buttonWrapper",
  "children": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__children",
  "column": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__column",
  "copy": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__copy",
  "cta": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__cta",
  "eyebrow": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__eyebrow",
  "fade-in": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__fade-in",
  "flushBottom": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__flushBottom",
  "flushTop": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__flushTop",
  "headline": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__headline",
  "imageOnLeft": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__imageOnLeft",
  "imageWrapper": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__imageWrapper",
  "inner": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__inner",
  "lastBlock": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__lastBlock",
  "lockup": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__lockup",
  "recipeDetail": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__recipeDetail",
  "recipes": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__recipes",
  "root": "BlockTwoColumnCarousel-module-scss-module__KeDfRq__root",
});
